import React from 'react'
import { hydrateRoot } from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { LocaleProvider } from './locales/useLocale'

function getInitialLocale() {
  if (typeof window !== 'undefined' && window.__INITIAL_LOCALE__) {
    return window.__INITIAL_LOCALE__
  }

  const lang = document.documentElement.lang
  if (lang === 'en') return 'en'
  if (lang === 'zh-TW') return 'zh-TW'
  if (lang === 'ja') return 'ja'
  return 'zh-TW'
}

hydrateRoot(document.getElementById('root'),
  <React.StrictMode>
    <LocaleProvider initialLocale={getInitialLocale()}>
      <App />
    </LocaleProvider>
  </React.StrictMode>,
)
